import { supabase } from "@/services/supabase/createClient";
import { v2 } from "@pufflig/prompt-studio-types";

export const appendConnectorToPromptbook = async (connectorId: string, promptbookId: string) => {
  const { data, error } = await supabase.rpc("get_promptbook", {
    promptbook_uuid: promptbookId,
  });

  if (error) return { error };

  if (!data?.[0]?.editor_state) {
    return { error: new Error("Promptbook does not have an editor state") };
  }

  const currentState = data[0].editor_state as unknown as v2.BasePromptbookState;

  const updatedState: v2.BasePromptbookState = {
    ...currentState,
    connectors: [...currentState.connectors],
  };

  updatedState.connectors.push(connectorId);

  const { error: updateError } = await supabase
    .from("promptbooks")
    .update({ editor_state: updatedState as any })
    .eq("resource_id", promptbookId);

  return { error: updateError };
};
